module.exports = __webpack_public_path__ + "img/clsedo.559e68a9.jpg";